import Tip from '../../images/tips.png'
import './TipsCard.scss'

function TipsCard({title, content, content2}) {
    return (
        <div className="tips-card-wrp">
            <img src={Tip} alt="tip"/>
            <div>
                <div className="title">{title}</div>
                <div className="content">{content}</div>
                <div className="content2">{content2}</div>
            </div>
        </div>
    );
}

export default TipsCard;